import React from 'react';

/**
 * PureSustain Ownership Notice
 *
 * Displayed on:
 * - Security Login Page
 * - Role Access Portal
 * - All authenticated pages (via DashboardLayout)
 * - Public QR Verification pages
 *
 * Two variants:
 *  - "footer"     → fixed at bottom (default)
 *  - "inline"     → inline block (use inside narrow forms)
 *  - "sidebar"    → compact, fits inside the sidebar bottom
 */
const OwnershipFooter = ({ variant = 'footer', className = '' }) => {
  const ownership =
    'PureSustain MVP is a product of and owned by PureSustain AS.';
  const disclaimer =
    'MVP demonstration environment. Data may include test, estimated, simulated, or live sensor data depending on deployment configuration.';

  if (variant === 'sidebar') {
    return (
      <div
        className={`px-4 pb-4 pt-3 border-t border-slate-200 ${className}`}
        data-testid="ownership-footer-sidebar"
      >
        <p className="text-[10px] leading-snug text-slate-500 font-medium">
          {ownership}
        </p>
        <p className="text-[10px] leading-snug text-slate-400 mt-1">
          {disclaimer}
        </p>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div
        className={`text-center ${className}`}
        data-testid="ownership-footer-inline"
      >
        <p className="text-[11px] text-slate-500 font-medium">{ownership}</p>
        <p className="text-[10px] text-slate-400 mt-1 leading-snug">
          {disclaimer}
        </p>
      </div>
    );
  }

  // footer (default)
  return (
    <footer
      className={`w-full border-t border-slate-200 bg-white/90 backdrop-blur-sm px-6 py-3 ${className}`}
      data-testid="ownership-footer"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-1 text-center sm:text-left">
        <p className="text-[11px] text-slate-600 font-medium">{ownership}</p>
        <p className="text-[10px] text-slate-400 leading-snug max-w-xl">
          {disclaimer}
        </p>
      </div>
    </footer>
  );
};

export default OwnershipFooter;
